import signin from "./views/signin.vue";
import signout from "./views/signout.vue";
import signup from "./views/signup.vue";
import signupvalid from "./views/signupvalid.vue";
import validate from "./views/validate.vue";
import resetpass from "./views/resetpass.vue";
import autologoff from "./views/autologoff.vue";
import unauthorised from "./views/unauthorised.vue";
import accesscompany from "./views/accesscompany.vue";
import accessfacility from "./views/accessfacility.vue";
import newpassword from "./views/newpassword.vue";
import userlicence from "./views/userlicence.vue";

const routes = [
  {
    path: "/signin",
    name: "signin",
    component: signin
  },
  {
    path: "/signout",
    name: "signout",
    component: signout
  },
  {
    path: "/signup",
    name: "signup",
    component: signup
  },
  {
    path: "/signupvalid",
    name: "signupvalid",
    component: signupvalid
  },
  {
    path: "/validate",
    name: "validate",
    component: validate
  },
  {
    path: "/resetpass",
    name: "resetpass",
    component: resetpass
  },
  {
    path: "/autologoff",
    name: "autologoff",
    component: autologoff
  },
  {
    path: "/unauthorised",
    name: "unauthorised",
    component: unauthorised
  },
  {
    path: "/accesscompany",
    name: "accesscompany",
    component: accesscompany
  },
  {
    path: "/accessfacility",
    name: "accessfacility",
    component: accessfacility
  },
  {
    path: "/userlicence",
    name: "userlicence",
    component: userlicence
  },
  {
    path: "/newpassword",
    name: "newpassword",
    component: newpassword
  }
];

export default routes;
